import { faArrowRight } from '@fortawesome/pro-solid-svg-icons'
import { ActionButton } from 'components'
import { AssignmentCardHeader, LoadStatusIcon } from 'components/load-assignments'
import { TripContext } from 'contexts'
import { LoadIndicator } from 'devextreme-react/load-indicator'
import React, { FC, Fragment, lazy, Suspense, useContext, useEffect, useState } from 'react'
import { useLoadManagerService, useNavigation } from 'services'
import { TripStatus } from 'services/enums'
import { Trip } from 'services/types'
import './assignment-card.scss'

const LoadSummary = lazy(() =>
    import('components/load-assignments')
        .then(({ LoadSummary }) => ({ default: LoadSummary })),
);

const ToAndFrom = lazy(() =>
    import('components/load-assignments')
        .then(({ ToAndFrom }) => ({ default: ToAndFrom })),
);

const TruckTrailer = lazy(() =>
    import('components/load-assignments')
        .then(({ TruckTrailer }) => ({ default: TruckTrailer })),
);

type Props = {
    loadId: number
}

export const AssignmentCard: FC<Props> = ({ loadId }) => {
    const { navigateTo } = useNavigation()
    const { getTrailerPadLocation } = useLoadManagerService()
    const [isLoadingTrailerPad, setIsLoadingTrailerPad] = useState<boolean>(true)
    const tripContext = useContext(TripContext)
    const load: Trip = tripContext.trips.find(t => t.id === loadId) ?? {} as Trip

    useEffect(() => {
        const getTrailerLocation = async () => {
            if (load.trailerDcLocation != null && load.status === TripStatus.Ready) {
                await getTrailerPadLocation(load)
                setIsLoadingTrailerPad(false)
            } else {
                setIsLoadingTrailerPad(false)
            }
        }

        getTrailerLocation()
    }, [])

    return (
        <Suspense fallback={<Fragment />}>
            <Fragment>
                {load ?
                    <div className={'card-material'}>
                        <AssignmentCardHeader tripId={load.id} />
                        <div className={'load-status-heading'}>
                            <div className={'load-status-icon'}>
                                <LoadStatusIcon status={load.status} />
                            </div>
                            <div className={'load-status-details'}>
                                <Suspense fallback={<Fragment />}>
                                    <TruckTrailer title={"Load"} value={load.loadNumber} />
                                    <TruckTrailer title={"Truck"} value={load.truckId} />
                                    <TruckTrailer title={"Trailer"} value={load.trailerId ?? 'N/A'} />
                                    {isLoadingTrailerPad ?
                                        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '.25em' }}>
                                            <LoadIndicator width={24} height={24} />
                                        </div>
                                        :
                                        <TruckTrailer title={"Pad"} value={load.trailerLocation && load.trailerLocation.locationCode ? load.trailerLocation.locationCode : 'N/A'} />
                                    }
                                </Suspense>
                            </div>
                        </div>
                        <ToAndFrom loadId={load.id} />
                        {(load.status === TripStatus.Ready || load.status === TripStatus.Started) &&
                            <LoadSummary loadId={load.id} />
                        }
                        {(load.status !== TripStatus.Waiting && load.status !== TripStatus.Importing) &&
                            <div className={'action-row'}>
                                <ActionButton
                                    icon={faArrowRight}
                                    buttonColor={'#82BC24'}
                                    onClick={() => navigateTo(`load-appointments?tripId=${load.id}`)}
                                    buttonText={load.status === TripStatus.Started ? 'Resume' : (load.status === TripStatus.Ready ? 'Start' : 'View')}
                                />
                            </div>
                        }
                    </div>
                    :
                    <div>No load information</div>
                }
            </Fragment>
        </Suspense>
    )
}